import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const MetricCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend, 
  trendValue, 
  onClick, 
  variant = 'default',
  className = '' 
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'revenue':
        return 'border-l-4 border-l-success bg-success/5';
      case 'staff':
        return 'border-l-4 border-l-primary bg-primary/5';
      case 'services':
        return 'border-l-4 border-l-warning bg-warning/5';
      case 'status':
        return 'border-l-4 border-l-accent bg-accent/5';
      default:
        return 'border-l-4 border-l-muted';
    }
  };

  const getTrendColor = () => {
    if (!trend) return 'text-muted-foreground';
    return trend === 'up' ? 'text-success' : trend === 'down' ? 'text-destructive' : 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus';
  };

  return (
    <div 
      className={`bg-card rounded-lg p-6 elevation-1 transition-smooth hover:elevation-2 cursor-pointer ${getVariantStyles()} ${className}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <div className={`p-2 rounded-lg ${
              variant === 'revenue' ? 'bg-success/10' :
              variant === 'staff' ? 'bg-primary/10' :
              variant === 'services' ? 'bg-warning/10' :
              variant === 'status' ? 'bg-accent/10' : 'bg-muted/10'
            }`}>
              <Icon 
                name={icon} 
                size={20} 
                className={
                  variant === 'revenue' ? 'text-success' :
                  variant === 'staff' ? 'text-primary' :
                  variant === 'services' ? 'text-warning' :
                  variant === 'status' ? 'text-accent' : 'text-muted-foreground'
                }
              />
            </div>
            <div>
              <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
              <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
            </div>
          </div>
          
          {subtitle && (
            <p className="text-sm text-muted-foreground mb-2">{subtitle}</p>
          )}
          
          {trend && trendValue && (
            <div className="flex items-center space-x-1">
              <Icon 
                name={getTrendIcon()} 
                size={16} 
                className={getTrendColor()}
              />
              <span className={`text-sm font-medium ${getTrendColor()}`}>
                {trendValue}
              </span>
              {/* <span className="text-sm text-muted-foreground">vs last month</span> */}
            </div>
          )}
        </div>
        
        <Button variant="ghost" size="icon" className="opacity-0 group-hover:opacity-100 transition-opacity">
          <Icon name="ExternalLink" size={16} />
        </Button>
      </div>
    </div>
  );
};

export default MetricCard;